<template>
  <div ref="cncTabMenu" :class="['cnc-tab-menu', size, { 'has-border': hasBorder, 'has-bg': hasBg, 'has-divider-line': hasDividerLine, 'not-arrow': isNotArrow }]" :style="{ width: width === 0 ? '100%' : `${width}px` }">
    <div v-if="isHasArrowLeft && hasArrow" class="section-left">
      <CncIconButton
        :size="size === 'large' ? 'medium' : 'small'"
        type="ghost"
        :iconName="{ name: 'ico_chevron_left' }"
        @click="scrollLeft"
      />
      <div class="divider-line"/>
    </div>
    <div
      :class="['tab-menu-container', { 'is-grab': canGrab }]"
      ref="menuContainer"
      @mousedown="startDragging"
      @mousemove="drag"
      @mouseup="stopDragging"
      @mouseleave="stopDragging"
    >
      <div
        :class="['tab-menu-item', { 'tab-menu-item-disabled': menu.disabled }]"
        :id="`tab-menu-item-${index+1}`"
        v-for="(menu, index) in menus"
        :key="index"
        @click="handleClick(menu)"
      >
        <div class="tab-menu-label">
          <CncIcon
            v-if="menu.icon"
            :name="menu.icon"
            :isTwoTone="activeMenuId === menu.id && !menu.disabled"
            :width="iconWidth"
            :color="getColorIcon(menu)"
          />
          <!-- <CncDropdown
            v-if="menu.dropdown"
            v-model="menu.dropdownValue"
            :label="menu.name"
            :options="menu.options"
            :labelColor="getLabelColor(menu)"
            :size="size === 'large' ? 'large' : 'medium'"
            @change="handleDropdownChange(menu)"
          /> -->
          <div :class="['txt-label', { 'txt-label-active': activeMenuId === menu.id }, { 'txt-label-disabled': menu.disabled }]">{{ menu.name }}</div>
        </div>
        <div class="tab-menu-item-line" :style="{ width: activeMenuId === menu.id ? '100%' : '0%' }"></div>
      </div>
    </div>
    <div v-if="isHasArrowRight && hasArrow" class="section-right">
      <div class="divider-line"/>
      <CncIconButton
        :size="size === 'large' ? 'medium' : 'small'"
        type="ghost"
        :iconName="{ name: 'ico_chevron_right' }"
        :width="iconWidth"
        @click="scrollRight"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    menus: { type: Array, required: true },
    hasBg: { type: Boolean, default: true },
    hasDividerLine: { type: Boolean, default: true },
    hasBorder: { type: Boolean, default: true },
    hasArrow: { type: Boolean, default: true },
    size: { type: String, default: 'large' },
    ignoreRouter: { type: Boolean },
    shouldCheckQuery: { type: Boolean }
  },
  data () {
    return {
      isHasArrowLeft: false,
      isHasArrowRight: false,
      isDragging: false,
      startX: 0,
      scrollLeftPosition: 0,
      activeMenuId: null,
      width: 0,
      forceScrollToActiveUpdate: false
    }
  },
  computed: {
    iconWidth () {
      return ['large', 'medium'].includes(this.size) ? 24 : 20
    },
    isNotArrow () {
      const isNotArrow = !this.hasArrow || !this.isHasArrowLeft || !this.isHasArrowRight
      return isNotArrow && !this.hasBorder
    },
    canGrab () {
      return this.isHasArrowLeft || this.isHasArrowRight
    }
  },
  watch: {
    'width' (newValue) {
      this.width = newValue
      this.getActiveMenu()
      this.scrollToActiveMenu()
    },
    '$route.path' (newValue) {
      this.getActiveMenu()
    },
    'activeMenuId' (newValue) {
      this.scrollToActiveMenu()
    },
    'forceScrollToActiveUpdate' (newValue) {
      this.scrollToActiveMenu()
    },
    '$store.state.windowWidth' (newValue) {
      this.$nextTick(() => {
        setTimeout(() => {
          this.width = 0
          this.forceScrollToActiveUpdate = !this.forceScrollToActiveUpdate
        }, 1000)
      })
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.width = this.$refs.cncTabMenu.clientWidth
      this.$refs.menuContainer.addEventListener('scroll', this.checkScroll)
      this.getActiveMenu()
      this.checkScroll()
      this.scrollToActiveMenu()
    })
    window.addEventListener('resize', this.checkScroll)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.checkScroll)
  },
  methods: {
    handleClick (menu) {
      this.$emit('change', menu)
      if (menu.disabled) return
      if (menu.href && !this.ignoreRouter) {
        if (this.checkActiveMenuByPath(menu)) return
        this.$router.push({ path: menu.href, query: menu.query })
      }
      if (this.ignoreRouter) {
        this.activeMenuId = menu.id
      }
    },
    checkScroll () {
      if (this.$refs.menuContainer) {
        this.isHasArrowLeft = this.$refs.menuContainer.scrollLeft > 0
        this.isHasArrowRight = this.$refs.menuContainer.scrollLeft < (this.$refs.menuContainer.scrollWidth - this.$refs.menuContainer.clientWidth)
      }
    },
    scrollToActiveMenu () {
      if (this.$refs.menuContainer) {
        const activeMenuIndex = this.activeMenuId
        const activeMenuElement = document.getElementById(`tab-menu-item-${activeMenuIndex}`)
        if (activeMenuElement) {
          const containerRect = this.$refs.menuContainer.getBoundingClientRect()
          const elementRect = activeMenuElement.getBoundingClientRect()
          const scrollLeft = this.$refs.menuContainer.scrollLeft + elementRect.left - containerRect.left - (containerRect.width - elementRect.width) / 2
          this.$refs.menuContainer.scrollTo({
            left: scrollLeft,
            behavior: 'smooth'
          })
        }
      }
    },
    scrollLeft () {
      if (this.$refs.menuContainer) {
        this.$refs.menuContainer.scrollBy({ left: -200, behavior: 'smooth' })
      }
    },
    scrollRight () {
      if (this.$refs.menuContainer) {
        this.$refs.menuContainer.scrollBy({ left: 200, behavior: 'smooth' })
      }
    },
    startDragging (e) {
      if (this.$refs.menuContainer) {
        this.isDragging = true
        this.startX = e.pageX - this.$refs.menuContainer.offsetLeft
        this.scrollLeftPosition = this.$refs.menuContainer.scrollLeft
      }
    },
    stopDragging () {
      if (this.$refs.menuContainer) {
        this.isDragging = false
      }
    },
    drag (e) {
      if (!this.isDragging) return
      e.preventDefault()
      const x = e.pageX - this.$refs.menuContainer.offsetLeft
      const walk = (x - this.startX) * 2
      if (this.$refs.menuContainer) {
        this.$refs.menuContainer.scrollLeft = this.scrollLeftPosition - walk
      }
    },
    getColorIcon (menu) {
      if (this.activeMenuId === menu.id && !menu.disabled) {
        return this.$store.state.color['primary-500']
      } else if (menu.disabled) {
        return this.$store.state.color['coolGrey-300']
      } else {
        return this.$store.state.color['coolGrey-500']
      }
    },
    getLabelColor (menu) {
      if (this.activeMenuId === menu.id && !menu.disabled) {
        return this.$store.state.color['primary-500']
      } else if (menu.disabled) {
        return this.$store.state.color['coolGrey-300']
      } else {
        return this.$store.state.color['coolGrey-900']
      }
    },
    getActiveMenu () {
      if (this.ignoreRouter) this.activeMenuId = this.menus?.find(menu => menu.active)?.id || this.menus[0]?.id || null
      else this.activeMenuId = this.menus?.find(menu => this.checkActiveMenuByPath(menu))?.id || null
    },
    checkActiveMenuByPath (menu) {
      const samePath = menu?.href?.replace(/\/$/, '') === this.$route.path.replace(/\/$/, '')
      const sameQuery = this.shouldCheckQuery && menu?.query ? this.checkActiveMenuByQuery(menu) : true
      const sameUrl = samePath && sameQuery
      const forceActive = menu?.forceActive || false
      return forceActive || sameUrl
    },
    checkActiveMenuByQuery (menu) {
      const sameQuery = menu?.query && Object.keys(menu.query).every(key => menu.query[key].toString() === this.$route.query[key].toString())
      return sameQuery
    }
  }
}
</script>

<style lang="scss">
.cnc-tab-menu {
  display: flex;
  align-items: center;
  width: 100%;
  border: 1px solid transparent;

  .section-left, .section-right {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 14px 6px;
    gap: 6px;

    .divider-line {
      width: 1px;
      height: 32px;
      background-color: $color-cool-grey-100;
    }
  }

  .tab-menu-container {
    overflow-x: auto;
    display: flex;
    flex-direction: row;
    gap: 32px;
    position: relative;
    overflow-x: auto;
    scroll-behavior: smooth;
    -ms-overflow-style: none;
    scrollbar-width: none;
    user-select: none;
    padding: 20px 20px 0px 20px;

    &.is-grab {
      cursor: grab;
    }

    &:active {
      cursor: grabbing;
    }

    .tab-menu-item {
      display: flex;
      flex-direction: column;
      gap: 16px;
      cursor: pointer;

      .tab-menu-label {
        display: flex;
        align-items: center;
        gap: 8px;

        .txt-label {
          font-size: 16px;
          font-weight: 500;
          line-height: 24px;
          color: $color-cool-grey-900;
          white-space: nowrap;
          transition: color 0.3s ease;

          &.txt-label-active {
            color: $color-primary-500;
          }

          &.txt-label-disabled {
            color: $color-cool-grey-300;
          }
        }
      }

      .tab-menu-item-line {
        height: 4px;
        background-color: $color-primary-500;
        transition: width 0.3s ease;
        border-radius: 10px;
      }

      &.tab-menu-item-disabled {
        cursor: not-allowed;
      }
    }

    &::-webkit-scrollbar {
      display: none;
    }
  }

  &.has-bg {
    background-color: $color-white;
  }

  &.has-divider-line {
    border-bottom: 1px solid $color-cool-grey-100;
  }

  &.has-border {
    border-radius: 16px;
    border: 1px solid $color-cool-grey-100;

    .tab-menu-container {
      border-bottom: none;
    }
  }

  &.not-arrow {
    .tab-menu-container {
      padding-left: 0px !important;
      padding-right: 0px !important;
    }
  }

  &.large {
    .section-left, .section-right {
      padding: 14px 6px;
    }

    .tab-menu-container {
      padding: 20px 20px 0px 20px;
      gap: 40px;

      .tab-menu-item {
        .tab-menu-label {
          gap: 8px;

          .txt-label {
            font: $font-style-title-lg-med;
          }
        }
      }
    }
  }

  &.medium {
    .section-left, .section-right {
      padding: 14px 6px;
    }

    .tab-menu-container {
      padding: 18px 18px 0px 18px;
      gap: 32px;

      .tab-menu-item {
        gap: 14px;

        .tab-menu-label {
          gap: 6px;

          .txt-label {
            font: $font-style-title-md-med;
          }
        }
      }
    }
  }

  &.small {
    .section-left, .section-right {
      padding: 8px 6px;
    }

    .tab-menu-container {
      gap: 24px;
      padding: 12px 12px 0px 12px;

      .tab-menu-item {
        gap: 10px;

        .tab-menu-label {
          gap: 4px;

          .txt-label {
            font: $font-style-title-sm-med;
          }
        }
      }
    }
  }
}
</style>
